import SmallContainer from '@components/ui/layout/SmallContainer';
import { Heading, Text } from '@components/ui/typography';
import { parseDate } from '@components/_blog/parse-date';
import { BlogTag, BlogTags } from '@components/_blog/Tags';
import { parse } from '@config/theme';
import { urlFor } from '@lib/sanity/url-for';
import Image from 'next/image';
import React, { FC } from 'react';
import { Author, BlogItem } from '__generated__/sanity';
import { blogNarrowWidth, spacingBottomM } from './spacings';
type BlogDetailIntroProps = Omit<BlogItem['fields']['summary'], 'author'> & {
  author: Author;
};
export const BlogDetailIntro: FC<BlogDetailIntroProps> = ({
  author,
  tags,
  date,
  summaryTitle
}) => {
  if (!author) {
    return null;
  }
  return <SmallContainer className={spacingBottomM}>
      <div className={blogNarrowWidth}>
        <div className={grid}>
          <Image width={48} height={48} src={urlFor((author as Author).avatar).toString()} alt={author.avatar.alt} className={image} />
          <div>
            <Text variant="bodyRegular" fontWeight="bold" color="shade800" mb="1">
              {author.name}
            </Text>
            <Text variant="bodySmall" color="shade500">
              {parseDate(date)}
            </Text>
          </div>
        </div>
        {tags && tags.length > 0 && <BlogTags>
            {tags.map(tag => <BlogTag key={tag}>{tag}</BlogTag>)}
          </BlogTags>}
        <Heading variant="h3" as="h1" mb={{
        _: '4',
        sm: '6',
        xl: '8'
      }} className={parse({
        mt: {
          _: '6',
          sm: '8'
        }
      })}>
          {summaryTitle}
        </Heading>
      </div>
    </SmallContainer>;
};
const image = "i1xi4c6o";
const grid = parse({
  display: 'grid',
  alignItems: 'center',
  mb: '4',
  mt: '40'
}, "g1kjxb74");

require("./Intro.linaria.module.css!=!../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./Intro.tsx");